<template>
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0537 1.54454C17.6429 1.06405 18.5114 1.09795 19.0605 1.64708L21.707 4.29356C22.0974 4.6841 22.0975 5.31716 21.707 5.70762C21.3166 6.09789 20.6834 6.09789 20.293 5.70762L18 3.41465L16.4141 5.00059L17.707 6.29356C18.0974 6.6841 18.0975 7.31716 17.707 7.70762C17.3166 8.09789 16.6834 8.09789 16.293 7.70762L15 6.41465L13.4619 7.95274C14.4252 9.21411 15 10.7906 15 12.5006C14.9998 16.6425 11.642 20.0006 7.5 20.0006C3.35799 20.0006 0.000208187 16.6425 0 12.5006C0 8.35846 3.35786 5.00059 7.5 5.00059C9.20957 5.00059 10.7856 5.57478 12.0469 6.5377L16.9395 1.64708L17.0537 1.54454ZM7.5 7.00059C4.46243 7.00059 2 9.46303 2 12.5006C2.00021 15.538 4.46256 18.0006 7.5 18.0006C10.5374 18.0006 12.9998 15.538 13 12.5006C13 10.9816 12.385 9.6083 11.3887 8.61192C10.3923 7.61552 9.01906 7.00059 7.5 7.00059Z" fill="white"/>
    </svg>
</template>

<script>

export default {
  name: 'ChangePasswordIcon',
  components: {
  },
  props: {
  },
  setup () {
  }
}
</script>

<style lang="scss" scoped>

</style>
